import React from 'react'
import createReactClass from 'create-react-class'

const MgFailed = createReactClass({
	render() {
		const { migrate, history } = this.props
		const migrationError = migrate.getIn(['errors', 'message'])
		return <div className="migration-box">
			<div className="col-xs-8 col-md-10 bv-landing-section">
				<i className="mdi mdi-close-circle-outline"></i>
				<p className="font-36 mb-2 color-0E134F proxima-regular">
					Migration Failed
				</p>
				<p className="v-center py-2" style={{justifyContent: 'center'}}>
					<a href={migrate.get('source_site')} target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-18 td-none">
						{migrate.get('source_site')}
					</a>
					<span className="mdi mdi-arrow-right margin-row font-20"></span>
					<a href={migrate.get('destination_site')} target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-18 td-none">
						{migrate.get('destination_site')}
					</a>
				</p>
				<div className="cw-border-1 mb-5"/>
				<div className="bv-error center-block">
					{ migrationError }
				</div>
				<a className="bv-primary-button bv-mobile-button" onClick={history.goBack}>Back to Site</a>
			</div>
		</div>
	}
})

export default MgFailed
